<template>
    <div class="registered">
        <!-- 头部 -->
        <div class="registered-top">
            <img src="@/assets/img/login/logo-h.png" alt />
            <p @click="toHome">
                返回首页
                <span></span>
            </p>
        </div>
        <!-- 主体 -->
        <div class="registered-body">
            <div class="registered-con">
                <!-- 表单 -->
                <div class="registered-form">
                    <h2>激活因异常导致冻结的通行证</h2>
                    <!-- 表单组合 -->
                    <div class="form-group">
                        <input
                            type="text"
                            class="form-input"
                            ref="inp"
                            v-model="form.passportName"
                            placeholder="通行证账号"
                            @focus="focusInput(1)"
                            @blur="blurInput(1)"
                        />
                        <!-- 表单右侧提示 -->
                        <div class="registered-model" v-show="registeredModel">
                            <span></span>
                            <li>英文、数字、“-”、“_”均可，长度6-16个字符</li>
                        </div>
                    </div>
                    <div class="form-group" style="display:flex">
                        <input
                            type="text"
                            class="form-inputcode"
                            v-model="form.smsCode"
                            placeholder="请输入验证码"
                        />
                        <button
                            class="form-buttoncode"
                            v-show="show"
                            @click="showCodeModel"
                        >
                            获取验证码
                        </button>
                        <button class="form-buttoncode" v-show="!show">
                            {{ count }} s
                        </button>
                    </div>
                    <div style="position: absolute;">
                        <imgCode
                            class="img-code"
                            ref="imgcodeThaw"
                            @confirm="defineCode"
                        ></imgCode>
                    </div>
                    <div class="register-wrong" v-text="wrongText"></div>
                    <div class="form-group">
                        <button class="form-button" @click.prevent="handlSbmit">
                            确认
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <!-- 底部 -->
        <div class="registered-footer">
            &reg; 2014-2019 杭州云智互联科技有限公司
        </div>
        <!-- 验证码模态框 -->
        <!-- <imgcode-modal ref="imgcodeThaw" @confirm="defineCode"></imgcode-modal> -->
    </div>
</template>

<script>
import { getUnFreezeSms } from "@/requests/user";
import { unfreezeAccount } from "@/requests/user";
import PAGE_API from "@/apis/pageApi";
// import ImgcodeModal from "_sc/ModalImgcode";
import imgCode from "_sc/imgCode";

export default {
    name: "accountThaw",
    components: {
        // ImgcodeModal,
        imgCode
    },
    data() {
        return {
            show: true, //显示倒计时
            count: "",
            timer: null,
            showMsg: false,
            showCode: false,
            codeModel: false, //显示验证码弹框
            registeredModel: false,
            registeredModel2: false,
            msgText: "",
            codeWrong: "",
            wrongText: "",
            captcha: "",
            form: {
                passportName: "",
                smsCode: "",
                imgCode: ""
            }
        };
    },
    methods: {
        async handlSbmit() {
            this.wrongText = "";
            let nameRe = this.$validateCenter.passportNameWhds(
                this.form.passportName
            );
            if (nameRe.res == false) {
                this.wrongText = nameRe.msg;
                return false;
            }
            let smsRe = this.$validateCenter.smsCode(this.form.smsCode);
            if (smsRe.res == false) {
                this.wrongText = smsRe.msg;
                return false;
            }
            let obj = {
                passportName: this.form.passportName,
                smsCode: this.form.smsCode
            };
            let res = await unfreezeAccount(obj);
            if (res.code == 200) {
                this.wrongText = res.msg;
                window.$msg({
                    showClose: true,
                    type: "success",
                    message: res.msg
                });
                this.$router.push({
                    path: PAGE_API.login.path
                });
            } else {
                this.wrongText = res.msg;
            }
        },
        //边框聚焦变色
        focusInput(index) {
            if (index == 1) {
                this.$refs.inp.style.border = "1px solid #00c2de";
                this.registeredModel = true;
            }
        },
        //失去焦点恢复颜色
        blurInput(index) {
            if (index == 1) {
                this.$refs.inp.style.border = "1px solid #dcdcdc";
                this.registeredModel = false;
            }
        },
        //去登录页
        toHome() {
            window.location.href = "/";
        },
        //获取验证码弹框
        showCodeModel() {
            this.wrongText = "";
            if (this.form.passportName == "") {
                this.wrongText = "账号不能为空";
                return false;
            }
            this.$refs.imgcodeThaw.show();
        },
        // 刷新验证码
        editCaptcha() {
            this.captcha = "?" + Math.random();
        },
        //关闭验证码弹框
        closeModel() {
            this.codeModel = false;
        },
        //验证码倒计时
        countDown() {
            const TIME_COUNT = 60;
            if (!this.timer) {
                this.count = TIME_COUNT;
                this.show = false;
                this.timer = setInterval(() => {
                    if (this.count > 0 && this.count <= TIME_COUNT) {
                        this.count--;
                    } else {
                        this.show = true;
                        clearInterval(this.timer);
                        this.timer = null;
                    }
                }, 1000);
            }
        },
        //确定验证码
        async defineCode(code) {
            let obj = {
                imgCode: code,
                passportName: this.form.passportName
            };
            let res = await getUnFreezeSms(obj);
            if (res.code == 200) {
                // this.codeModel = false
                this.$refs.imgcodeThaw.hide();
                this.countDown();
            } else {
                this.wrongText = res.msg;
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.registered {
    width: 100%;
    height: 100vh;
    min-height: 920px;
    background-color: #f5f5f6;
    background-size: cover;
    background-position: center;
    position: relative;
    // 顶部
    .registered-top {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        height: 60px;
        background-color: #f5f5f6;
        border-bottom: 1px solid #d7d8d9;
        img {
            margin-left: 30px;
            width: 124px;
            height: 30px;
        }
        p {
            margin-right: 20px;
            font-size: 15px;
            color: #383d41;
            font-weight: bold;
            cursor: pointer;
            span {
                display: block;
                float: right;
                margin-top: 4px;
                margin-left: 5px;
                width: 12px;
                height: 12px;
                background: url(../../assets/img/icon/箭头.png);
            }
        }
        p:hover {
            color: #00c2de;
        }
    }
    // 主体
    .registered-body {
        display: flex;
        justify-content: center;
        width: 100%;
        background-size: 90% 100%;
        background-position: center bottom;
        .registered-con {
            display: flex;
            justify-content: center;
            margin-top: 80px;
            width: 1000px;
            height: 530px;
            background-color: #fff;
            // 表单
            .registered-form {
                width: 420px;
                h2 {
                    font-size: 30px;
                    color: #373d41;
                    font-weight: bold;
                    line-height: 100px;
                }
                .form-group {
                    margin-left: 50px;
                    width: 80%;
                    padding: 10px 0;
                    // 表单输入框
                    .form-input {
                        padding-left: 10px;
                        width: 96.5%;
                        height: 40px;
                        font-weight: bold;
                        border: 1px solid #dcdcdc;
                        color: #000;
                        outline: none;
                        transition: all 0.7s;
                    }
                    // 表单按钮
                    .form-button {
                        margin-top: 40px;
                        width: 100%;
                        height: 40px;
                        font-weight: bold;
                        border: none;
                        outline: none;
                        color: #fff;
                        background-color: #00c6de;
                    }
                    .registered-model {
                        position: absolute;
                        transform: translate(335px, -41px);
                        width: 293px;
                        height: 40px;
                        span {
                            position: absolute;
                            transform: translate(-5px, 15px);
                            display: block;
                            width: 1px;
                            height: 1px;
                            border-width: 7px;
                            border-style: solid dashed dashed;
                            border-color: transparent #fff transparent
                                transparent;
                            font-size: 0;
                            line-height: 0;
                        }
                        li {
                            margin-left: 10px;
                            width: 280px;
                            height: 100%;
                            box-shadow: 0px 0px 15px 0px rgb(116, 114, 114);
                            list-style-type: disc;
                            line-height: 40px;
                            color: #666;
                        }
                    }
                    // 验证码输入框
                    .form-inputcode {
                        padding-left: 10px;
                        width: 69%;
                        height: 40px;
                        border: 1px solid #00c6de;
                        color: #000;
                        font-weight: bold;
                        background-color: #ddf8fc;
                    }
                    // 验证码按钮
                    .form-buttoncode {
                        width: 29%;
                        height: 42px;
                        border: 1px solid #00c6de;
                        background-color: #ddf8fc;
                        border-left: none;
                        color: #20c6e0;
                        font-weight: bold;
                    }
                }
            }
        }
    }
    // 底部
    .registered-footer {
        position: absolute;
        bottom: 0;
        width: 100%;
        height: 60px;
        background-color: #383d41;
        color: #84878c;
        text-align: center;
        line-height: 60px;
        font-size: 16px;
    }
    // 验证码模态框
    .code-model {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.5);
        .model-body {
            position: fixed;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: 360px;
            height: 300px;
            background-color: #fff;
            h5 {
                // width: 100%;
                background: #363636;
                border-left: 8px solid #09f;
                line-height: 40px;
                color: #fff;
                text-align: left;
                padding-left: 13px;
                margin: 0;
            }
            span {
                position: absolute;
                top: 10px;
                right: 10px;
                color: #fff;
                font-size: 16px;
                cursor: pointer;
            }
            span:hover {
                color: #f00;
            }
            p {
                img {
                    width: 180px;
                    height: 50px;
                    display: block;
                    margin: 24px auto;
                }
                input {
                    margin-top: 10px;
                    height: 60px;
                    width: 100%;
                    padding: 0;
                    border-radius: 0px;
                    color: #333;
                    font-size: 16px;
                    line-height: 60px;
                    border: 0px;
                    border-bottom: 1px solid #a1a1a1;
                    text-align: center;
                }
                button {
                    width: 128px;
                    margin: 0 auto;
                    padding: 0;
                    font-size: 18px;
                    height: 40px;
                    line-height: 40px;
                    background: #09c;
                    color: #fff;
                    border: 0;
                }
            }
            .wrong {
                color: #f33;
                font-size: 12px;
                line-height: 28px;
                height: 28px;
                margin: 8px 0;
                text-align: center;
            }
        }
    }
    .register-wrong {
        position: absolute;
        // transform: translate(0px,-0px);
        // padding-left: 10px;
        width: 420px;
        line-height: 40px;
        color: #f00;
        font-size: 12px;
    }
}
.img-code {
    left: 270px;
}
</style>
